var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8599_26717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.25 0 0 10.125 0 22.5C0 34.875 11.25 45 25 45C38.75 45 50 34.875 50 22.5C50 10.125 38.75 0 25 0ZM25 7.5C29.5833 7.5 33.3333 11.625 33.3333 16.875C33.3333 22.125 29.5833 26.25 25 26.25C20.4167 26.25 16.6667 22.125 16.6667 16.875C16.6667 11.625 20.4167 7.5 25 7.5ZM38.75 36.5625C35.2083 39.375 30.2083 41.25 25 41.25C19.7917 41.25 14.7917 39.375 11.25 36.5625C10.4167 35.8125 10.2083 34.6875 11.0417 33.9375C13.3333 31.5 16.4583 29.8125 19.7917 28.875C21.4583 29.625 23.125 30 25 30C26.875 30 28.5417 29.625 30.2083 28.875C33.75 29.8125 36.6667 31.5 38.9583 33.9375C39.7917 34.6875 39.7917 35.8125 38.75 36.5625Z",
    fill: "#D6CEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8599_26717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.a214b838ed576b19a1a4e0a71b8ac72c.svg";
export { ForwardRef as ReactComponent };